import { render } from "./StockChat.vue?vue&type=template&id=40e167cd&scoped=true&ts=true"
import script from "./StockChat.vue?vue&type=script&lang=ts"
export * from "./StockChat.vue?vue&type=script&lang=ts"

import "./StockChat.vue?vue&type=style&index=0&id=40e167cd&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e167cd"]])

export default __exports__